import { ContactFormData, ValidationErrors } from '../types/api';

export const validateContactForm = (data: ContactFormData): ValidationErrors => {
    const errors: ValidationErrors = {};

    // Name validation
    if (!data.name.trim()) {
        errors.name = 'Name is required';
    } else if (data.name.trim().length < 2) {
        errors.name = 'Name must be at least 2 characters';
    } else if (data.name.trim().length > 100) {
        errors.name = 'Name must be less than 100 characters';
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!data.email.trim()) {
        errors.email = 'Email is required';
    } else if (!emailRegex.test(data.email)) {
        errors.email = 'Please enter a valid email address';
    } else if (data.email.length > 150) {
        errors.email = 'Email must be less than 150 characters';
    }

    // Message validation
    if (!data.message.trim()) {
        errors.message = 'Message is required';
    } else if (data.message.trim().length < 10) {
        errors.message = 'Message must be at least 10 characters';
    } else if (data.message.trim().length > 2000) {
        errors.message = 'Message must be less than 2000 characters';
    }

    return errors;
};

export const hasValidationErrors = (errors: ValidationErrors): boolean => {
    return Object.keys(errors).length > 0;
};